import { render } from "./roombooking.vue?vue&type=template&id=2e521415&scoped=true"
import script from "./roombooking.vue?vue&type=script&lang=js"
export * from "./roombooking.vue?vue&type=script&lang=js"

import "./roombooking.vue?vue&type=style&index=0&id=2e521415&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e521415"]])

export default __exports__